import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProjectStructureSelection } from "./projectStructureTypes";

export const samProjectStructureSliceName = "samProjectStructure";

export interface SamProjectStructureState {
  selection: ProjectStructureSelection;
  selectByPartlistEntryIds: string[] | undefined;
}

const initialState: SamProjectStructureState = {
  selection: { nodeIds: [] },
  selectByPartlistEntryIds: undefined,
};

const samSlice = createSlice({
  name: samProjectStructureSliceName,
  initialState,
  reducers: {
    setProjectStructureSelection(state: SamProjectStructureState, action: PayloadAction<ProjectStructureSelection>) {
      state.selection = action.payload;
    },
    setProjectStructureSelectByPartlistEntryIds(state: SamProjectStructureState, action: PayloadAction<string[] | undefined>) {
      state.selectByPartlistEntryIds = action.payload;
    },
  },
});

export interface SamProjectStructureRootState {
  [samProjectStructureSliceName]: SamProjectStructureState;
}

export const selectSamProjectStructure = (state: SamProjectStructureRootState) => state[samProjectStructureSliceName];
export const selectSamProjectStructureSelection = (state: SamProjectStructureRootState) => {
  return selectSamProjectStructure(state).selection;
};
export const selectSamProjectStructureSelectByPartlistEntryIds = (state: SamProjectStructureRootState) => {
  return selectSamProjectStructure(state).selectByPartlistEntryIds;
};

export const { setProjectStructureSelection, setProjectStructureSelectByPartlistEntryIds } = samSlice.actions;
export const samProjectStructureReducer = samSlice.reducer;
